export enum AuthRoutes {
  blank = '/',
  dashboard = '/dashboard',
  users = '/users',
  profile = '/profile',
  changePassword = '/change-password',
  developers = '/developers',
  properties = '/properties',
}

export enum RouteParamsTypes {
  any = '/*',
  id = '/:id',
  blank = '',
  add = '/add',
  edit = '/edit',
  view = '/view',
  list = '/list',
}

export enum Modules {
  auth = '/auth',
  home = '/home',
  users = '/users',
  properties = '/properties',
  error = '/error',
  my = '/my',
  developers = '/developers',
}

export enum NonAuthRoutes {
  login = '/login',
  forbidden = '/forbidden',
  unHandledRejection = '/server-error',
  notFound = '/page-not-found',
  forgotPassword = '/forgot-password',
  resetPassword = '/reset-password',
}

export enum PermissionActionsEnum {
  View = 'view',
  Add = 'add',
  Update = 'update',
  Delete = 'delete',
  Email = 'email',
  Export = 'export',
  Import = 'import',
}

export enum PermissionModulesEnum {
  Users = 'users',
  Dashboard = 'dashboard',
  Developers = 'developers',
  Properties = 'properties',
}

export enum SortOrder {
  asc = 'ASC',
  desc = 'DESC',
}

export enum RowClassName {
  even = 'even',
  odd = 'odd',
}

export enum RoleCodes {
  system_admin = 'system_admin',
  admin = 'admin',
  manager = 'manager',
}
